/**
 * safeUUID.ts
 * Cross-environment safe UUID generator with fallback for non-secure HTTP contexts.
 */

export function safeUUID(): string {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    try {
      return crypto.randomUUID();
    } catch {
      // fallback if crypto.randomUUID fails
    }
  }
  return "id-" + Math.random().toString(36).substring(2, 11) + "-" + Date.now().toString(36);
}
